
const Loader = () => (
  <div className="w-full h-screen flex flex-col justify-center items-center fixed z-[1000] bg-white bg-opacity-10 backdrop-filter backdrop-blur-sm">
    <div className="loader-dots"></div>
  </div>
);

export default Loader;
